/**
 *  Microtaskers
 *  Nom: ANDRIARILALAO Johny Lino
 *  Email: johny.andriarilalao@gmail.com
 */

import React, { lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SuspenseView } from 'public/shared/components/SuspenseView';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/toast.css';

const AppRoutes: React.FC = () => {
  const AdminRoutes = lazy(() => import('./AdminRoutes'));
  const PrivatesRoutes = lazy(() => import('./PrivatesRoutes'));
  const PublicEventRegistrationPage = lazy(
    () => import('features/public-event-registration/pages/PublicEventRegistrationPage')
  );
  const PublicRegistrationSuccessPage = lazy(
    () => import('features/public-event-registration/pages/PublicRegistrationSuccessPage')
  );
  const PublicRegistrationPaymentCallbackPage = lazy(
    () => import('features/public-event-registration/pages/PublicRegistrationPaymentCallbackPage')
  );
  const PublicRegistrationCheckoutPage = lazy(
    () => import('features/public-event-registration/pages/PublicRegistrationCheckoutPage')
  );

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route>
            <Route
              path="admin/*"
              element={
                <SuspenseView>
                  <AdminRoutes />
                </SuspenseView>
              }
            />
            <Route
              path="register/:eventSlug/success"
              element={
                <SuspenseView>
                  <PublicRegistrationSuccessPage />
                </SuspenseView>
              }
            />
            <Route
              path="register/payment/cancel"
              element={
                <SuspenseView>
                  <PublicRegistrationPaymentCallbackPage type="cancel" />
                </SuspenseView>
              }
            />
            <Route
              path="register/payment/error"
              element={
                <SuspenseView>
                  <PublicRegistrationPaymentCallbackPage type="error" />
                </SuspenseView>
              }
            />
            <Route
              path="register/payment/success"
              element={
                <SuspenseView>
                  <PublicRegistrationPaymentCallbackPage type="success" />
                </SuspenseView>
              }
            />
            <Route
              path="evenement/billetterie/annuler"
              element={
                <SuspenseView>
                  <PublicRegistrationPaymentCallbackPage type="cancel" />
                </SuspenseView>
              }
            />
            <Route
              path="evenement/billetterie/erreur"
              element={
                <SuspenseView>
                  <PublicRegistrationPaymentCallbackPage type="error" />
                </SuspenseView>
              }
            />
            <Route
              path="evenement/billetterie/succes"
              element={
                <SuspenseView>
                  <PublicRegistrationPaymentCallbackPage type="success" />
                </SuspenseView>
              }
            />
            <Route
              path="register/:eventSlug"
              element={
                <SuspenseView>
                  <PublicEventRegistrationPage />
                </SuspenseView>
              }
            />
            <Route
              path="register/:eventSlug/checkout"
              element={
                <SuspenseView>
                  <PublicRegistrationCheckoutPage />
                </SuspenseView>
              }
            />
            <Route
              path="/*"
              element={
                <SuspenseView>
                  <PrivatesRoutes />
                </SuspenseView>
              }
            />
            <Route path="*" element={<Navigate to="/admin/auth/login" replace={true} />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer 
        position="top-center" 
        autoClose={10000}
        newestOnTop
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default AppRoutes;
